import React from 'react';
import branch from 'recompose/branch';
import renderComponent from 'recompose/renderComponent';
import Message from '../Message';

export default branch(
  ({ data }) => data && data.error,
  renderComponent(({ data }) => (<Message error header="Oops, something went wrong" content={data.error.message} />)),
);
